import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';

interface ItemQuantityCostRowProps {
  quantity: number;
  cost: number;
}

const ItemQuantityCostRow = ({ quantity, cost }: ItemQuantityCostRowProps) => {
  return (
    <div className="sui-flex sui-items-center sui-gap-2 sui-mt-1">
      <Typography height="tight" size="base">
        Qty: {quantity}
      </Typography>
      <Typography height="tight" size="base">
        |
      </Typography>
      <Typography weight="bold" height="tight" size="base">
        ${(cost * quantity).toFixed(2)}
      </Typography>
    </div>
  );
};

export default ItemQuantityCostRow;
